import { savingsOverviewNn } from '@apps/savings-overview/translations/nn';
import { fundListNn } from '@fund-list/translations/nn';
import { commonNn } from '@shared/translations/common/nn';
import { fundGuideNn } from '@shared/translations/fund-guide/nn';
import { transferShareSavingsAccountFormNn } from '@transfer-share-savings-account/translations/nn';
export const nnTranslations = {
    ...commonNn,
    ...fundGuideNn,
    ...fundListNn,
    ...savingsOverviewNn,
    ...transferShareSavingsAccountFormNn,
    errors: {
        ...commonNn.errors,
        ...fundListNn.errors,
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm4tdHJhbnNsYXRpb25zLWNvbmZpZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy90cmFuc2xhdGlvbnMvbm4tdHJhbnNsYXRpb25zLWNvbmZpZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsaUJBQWlCLEVBQUUsTUFBTSx3Q0FBd0MsQ0FBQztBQUMzRSxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sNEJBQTRCLENBQUM7QUFDeEQsT0FBTyxFQUFFLFFBQVEsRUFBRSxNQUFNLGdDQUFnQyxDQUFDO0FBQzFELE9BQU8sRUFBRSxXQUFXLEVBQUUsTUFBTSxvQ0FBb0MsQ0FBQztBQUNqRSxPQUFPLEVBQUUsaUNBQWlDLEVBQUUsTUFBTSxpREFBaUQsQ0FBQztBQUlwRyxNQUFNLENBQUMsTUFBTSxjQUFjLEdBQTJCO0lBQ2xELEdBQUcsUUFBUTtJQUNYLEdBQUcsV0FBVztJQUNkLEdBQUcsVUFBVTtJQUNiLEdBQUcsaUJBQWlCO0lBQ3BCLEdBQUcsaUNBQWlDO0lBQ3BDLE1BQU0sRUFBRTtRQUNKLEdBQUcsUUFBUSxDQUFDLE1BQU07UUFDbEIsR0FBRyxVQUFVLENBQUMsTUFBTTtLQUN2QjtDQUNKLENBQUMifQ==